import Repasses from './repasses';

export default Repasses;
